module.exports = __webpack_public_path__ + "static/tat-45-876f59f2794bb40cc4801fe8e6b612bd.jpg";